"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const TRANSITIONS = {
  transition: 'transitionend',
  OTransition: 'oTransitionEnd',
  MozTransition: 'transitionend',
  WebkitTransition: 'webkitTransitionEnd'
};
function transitionEventNamesFor(element) {
  const transitionKey = Object.keys(TRANSITIONS).find(transition => element && element.style[transition] !== undefined);
  return TRANSITIONS[transitionKey];
}
var _default = exports.default = {
  on(el, type, callback, eventCatch = false) {
    if (el.addEventListener) {
      el.addEventListener(type, callback, eventCatch);
    } else {
      el.attachEvent(`on${type}`, () => {
        callback.call(el);
      });
    }
  },
  off(el, type, callback, eventCatch = false) {
    if (el.removeEventListener) {
      el.removeEventListener(type, callback, eventCatch);
    } else {
      el.detachEvent(`on${type}`, callback);
    }
  },
  addEventListenerOnTransitionEnded(element, fn) {
    const eventName = transitionEventNamesFor(element);
    if (!eventName) return false;
    element.addEventListener(eventName, fn);
    return true;
  },
  removeEventListenerOnTransitionEnded(element, fn) {
    const eventName = transitionEventNamesFor(element);
    if (!eventName) return false;
    element.removeEventListener(eventName, fn);
    return true;
  },
  triggerChangeEvent(input, newValue) {
    Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set.call(input, String(newValue));
    input.dispatchEvent(new Event('change', {
      bubbles: true
    }));
  }
};